/*global acc*/
import $ from 'jquery';
import {EVENT_KEYBOARD_NAV_OPENED,EVENT_TOGGLE_TOOLBAR} from '../Params'
import {isEmpty,locale} from '../Helpers'

export default  class KeyboardNav {

    constructor() {
        this._data= {}
        this.bodyClass = '*';
        this.visible = true;
        this.on_side = false;
        this.items=acc.keybordVavItems;

    }

    get on_side(){ return this._data.on_side}
    set on_side(x){ this._data.on_side = x }

    get items(){ return this._data.items}
    set items(x){ this._data.items = x }

    get bodyClass(){ return this._data.bodyClass}
    set bodyClass(x){ this._data.bodyClass = x }

    get visible(){ return this._data.visible}
    set visible(x){
        if(isEmpty(this.elem)){return}
        if(this._data.visible===x){return}
        this._data.visible =x;
        this.elem.toggle(x)
        this.elem.attr('aria-hidden',(x ? 'false' : 'true'))

    }

    focus(){
        this.elem.focus()
    }
    open(){
        $('body').prepend(this.render());
        $('body').addClass('hasNav');
        this.visible = true;
        $(document).trigger(EVENT_KEYBOARD_NAV_OPENED);
        this.focus()
    }

    get_items_for_page(){
        let items = this.items[0].items
        const bodyClasses = $('body').attr('class').split(" ");

        this.items.map((set)=>{
            let found =  bodyClasses.some(c=>c.indexOf(set.name) == 0)
            if($('body').hasClass(set.name) || found){
                this.bodyClass = set.name;
                items = set.items;
            }
        })
        return items
    }
    render(){
        this.elem = $('<nav>',{
            id:"accessKeybordNav",
            role:"menu",
            tabindex:"0",
            'aria-label':locale('quick_navigation'),
            'aria-hidden':'false'});

        this.elem.toggleClass('en',locale('lang') === 'en_US');
        this.elem.toggleClass('on_side',this.on_side);
        const items = this.get_items_for_page();
        this.elem.append(
            items.map((item)=>{
                let navitem = $('<a>',{'href':item.target}).text(item.label)
                return navitem
            })
        )
        const accTarget = $('<a>',{'href':'#'}).text(locale('accessibility_menu')).click((e)=>{
            e.preventDefault();
            $(document).trigger(EVENT_TOGGLE_TOOLBAR, {isOpen: true});
        })
        const back = $('<span class="backhere">').html(locale('back_to_this_menu')+'<span class="keyboard-style">Esc</span></span>')
        this.elem.append(accTarget,back)

        this.elem.keydown(function(e){
            //press Esc:
            let keyCode = e.keyCode || e.which;
            if (keyCode=== 27) {
                return false;
            }
        });
        return this.elem;
    }

    destroy(){
        this.elem = null
        $('body').removeClass('hasNav')
        $('#accessKeybordNav').remove()

    }

}